/**
 * Normalizes tempzone values to standard format by removing suffixes
 *
 * This function handles EU tempzone formats that include suffixes (e.g., "AMBIENT-24")
 * and normalizes them to standard formats (e.g., "AMBIENT") to ensure proper aggregation
 * of forecast data across different inbound flow types (DR and TSI).
 *
 * @param {string} tempZone - Raw tempzone value from the data source
 * @returns {string} Normalized tempzone value
 *
 * @example
 * normalizeTempZone("AMBIENT-24") // returns "AMBIENT"
 * normalizeTempZone("FROZEN-12")  // returns "FROZEN"
 * normalizeTempZone("CHILLED")    // returns "CHILLED"
 * normalizeTempZone("PROTEIN")    // returns "PROTEIN"
 */
export function normalizeTempZone(tempZone) {
  if (!tempZone || typeof tempZone !== 'string') {
    return tempZone ?? '';
  }

  // Remove suffix pattern like "-24", "-12" etc.
  // Match standard tempzones: AMBIENT, FROZEN, CHILLED, PROTEIN, PRODUCE
  const match = /^(AMBIENT|FROZEN|CHILLED|PROTEIN|PRODUCE)/i.exec(tempZone);

  if (match) {
    // Return the base tempzone in uppercase
    return match[1].toUpperCase();
  }

  // If no match, return original (for unknown tempzones)
  return tempZone;
}
